import { Flex } from 'web-styled';

import AddActionsDropdown from './AddActionsDropdown';
import HelpDropdown from './HelpDropdown';
import ProfileDropdown from './ProfileDropdown';
import SearchSection from './SearchSection';
import type { HeaderProps } from './types';
import useDropdownState from './useDropdownState';
import * as S from './styled';
const Header = ({
  isPro,
  avatar,
  addActions,
  profileActions,
  namespace,
  searchQuery,
  searchSections,
  setSearchQuery,
  onKeyDown,
  onSearchSubmit,
}: HeaderProps) => {
  const { dropdownState, toggleDropdown, closeDropdown } = useDropdownState();

  return (
    <S.Header>
      {isPro && (
        <SearchSection
          searchQuery={searchQuery}
          searchSections={searchSections}
          setSearchQuery={setSearchQuery}
          onKeyDown={onKeyDown}
          onSearchSubmit={onSearchSubmit}
        />
      )}

      <Flex margin="0 0 0 auto">
        {isPro && (
          <AddActionsDropdown
            isOpen={dropdownState.addActions}
            addActions={addActions}
            onToggle={() => toggleDropdown('addActions')}
            onClose={() => closeDropdown('addActions')}
          />
        )}

        <HelpDropdown
          isOpen={dropdownState.help}
          isPro={isPro}
          namespace={namespace}
          onToggle={() => toggleDropdown('help')}
          onClose={() => closeDropdown('help')}
        />

        <ProfileDropdown
          isOpen={dropdownState.menu}
          isPro={isPro}
          avatar={avatar}
          namespace={namespace}
          profileActions={profileActions}
          onToggle={() => toggleDropdown('menu')}
          onClose={() => closeDropdown('menu')}
        />
      </Flex>
    </S.Header>
  );
};

export default Header;
